import { configureStore } from '@reduxjs/toolkit'
import { thunk } from 'redux-thunk'
import { combineReducers } from 'redux'
import { initCustomReducers } from './setup'

import coreReducer from './core/utils/reducer'
import inventoryReducer from './custom/Inventory Management/redux/inventorySlice'
import purchaseOrdersReducer from './custom/Inventory Management/redux/purchaseOrderSlice'

const customReducers = initCustomReducers()
const store = configureStore({
  reducer: combineReducers({
    core: coreReducer.reducer,
    ...customReducers,
    inventory: inventoryReducer,
    purchaseOrders: purchaseOrdersReducer
  }),
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false
    }).concat(thunk)
})

export default store
